import { Currency } from '@seapoint/server/enums';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';
import { PayrollView } from '../../../../types/entity-types';
import { getAmountWithCurrency } from '../../../../utils/get-amount-with-currency';
import { PayrollSummaryCard } from './payroll-summary-card';
import { PayrollSummaryTable } from './payroll-summary-table/payroll-summary-table';

type PayrollApprovalWrapperProps = {
  payroll?: PayrollView | null;
  currency?: Currency;
  isLoading: boolean;
  onContinue: () => void;
  onEditPayrollRecord: (payrollRecordId: string) => void;
};

export const PayrollApprovalWrapper = ({
  payroll,
  currency,
  isLoading,
  onContinue,
  onEditPayrollRecord,
}: PayrollApprovalWrapperProps) => {
  if (!currency || !payroll) {
    return null;
  }
  const totalNetPay = payroll.records.reduce((acc, record) => acc + record.netPay, 0);

  return (
    <Stack space={4} className="mt-10 w-full" align="end">
      <Inline className="w-full">
        <div className="flex-1">
          <PayrollSummaryCard
            payrollName={payroll.name}
            country={payroll.country}
            period={payroll.period}
            company={payroll.company.legalEntity.name}
            status={payroll.status}
          />
        </div>

        <Stack className="rounded-lg bg-white px-5 py-4" align="end" space={2}>
          <p className="text-sm text-seapoint-gray-text">Total net pay</p>
          <p className="text-lg font-semibold">
            {getAmountWithCurrency({
              amount: totalNetPay,
              currency: payroll.currency,
              isAccountBalance: true,
            })}
          </p>
        </Stack>
      </Inline>
      <Inline space={2} className="mt-4 w-full" wrap="nowrap">
        <h2 className="text-xl font-semibold">Payroll</h2>
        <p className="text-sm text-seapoint-gray-text">({payroll.records.length})</p>
      </Inline>
      <PayrollSummaryTable records={payroll.records} onEditPayrollRecord={onEditPayrollRecord} />

      <Button onClick={onContinue} isLoading={isLoading} disabled={isLoading}>
        Approve
      </Button>
    </Stack>
  );
};
